<!--  contactStatus:
 1: No Customer in Optimo
 2: Optimo contact is inactive
 3: Contact is exists in optimo,
 4: contact load failed,
 -->
<div style="display: none">contactStatus is {{ contactStatus }}</div>
<div *ngIf="contactStatus == 2">
  <opt-callout-box
    [status]="'opt-callout-warning'"
    [mainHeader]="'Customer Profile'"
    [bodyText]="
      'Your account is inactive. Please contact the council to reactivate it.'
    "
  >
  </opt-callout-box>
</div>
<div *ngIf="contactStatus == 3">
  <opt-callout-box
    [status]="'opt-callout-warning'"
    [mainHeader]="'Email already in use'"
    [bodyText]="
      'Customer already exists with same email, please contact council for more details.'
    "
  >
  </opt-callout-box>
</div>

<div *ngIf="contactStatus == 4">
  <opt-callout-box
    [status]="'opt-callout-warning'"
    [mainHeader]="'Access to your account is currently restricted'"
    [bodyText]="
      'Error processing your request. Please contact the council to reactivate your account.'
    "
  >
  </opt-callout-box>
</div>
